import * as React from 'react';

import { PageRowLayout } from '../PageRowLayout';
import { FavoriteButtonContainer } from '../../containers/FavoriteButton';
import * as style from './CarouselOverlayPanel.css';
import { NewbuildingReviewsStatContainer } from '../../containers/NewbuildingReviewsStat';
import { NewbuildingCompareButton } from '../../containers/NewbuildingCompareButton';
import { COMPARISON_ENTRYPOINTS_ENABLED_CONFIG } from '../../containers/Comparison/constants';
import { useApplicationContext } from '../../utils/applicationContext';

export const CarouselOverlayPanel = () => {
  const { config } = useApplicationContext();
  const isComparisonEntrypointsEnabled = config.get<boolean>(COMPARISON_ENTRYPOINTS_ENABLED_CONFIG) || false;

  return (
    <PageRowLayout>
      <div className={style['rating']}>
        <NewbuildingReviewsStatContainer />
      </div>
      <div className={style['list']} data-testid="CarouselOverlayButtonsArea">
        <div className={style['item']}>
          <NewbuildingCompareButton
            withOnboarding={true}
            addToCompareText={isComparisonEntrypointsEnabled ? 'В сравнение' : undefined}
            source="header"
          />
        </div>
        <div className={style['item']}>
          <FavoriteButtonContainer />
        </div>
      </div>
    </PageRowLayout>
  );
};
